import { createActions } from 'redux-actions';

export const {
  updateFilterFieldsExecutors,
  searchExecutors,
  changeTypeListExecutors,
  countFiltersExecutors,
  resetFiltersExecutors,
} = createActions(
  'UPDATE_FILTER_FIELDS_EXECUTORS',
  'SEARCH_EXECUTORS',
  'CHANGE_TYPE_LIST_EXECUTORS',
  'COUNT_FILTERS_EXECUTORS',
  'RESET_FILTERS_EXECUTORS'
);
